import { motion } from "framer-motion";
import { FEATURES } from "@/data/content";
import { Reveal } from "./Reveal";

const Card = ({ f, i }) => {
  const Icon = f.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -4 }}
      className={`group relative overflow-hidden rounded-2xl border border-white/5 bg-[#121212] p-7 transition-colors duration-300 hover:border-[#D4F870]/40 md:p-9 ${f.span}`}
      data-testid={`feature-card-${i}`}
    >
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#D4F870]/0 blur-3xl transition-all duration-500 group-hover:bg-[#D4F870]/10" />
      <div className="mb-6 grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-[#1A1A1A] text-[#D4F870]">
        <Icon className="h-5 w-5" strokeWidth={1.75} />
      </div>
      <h3 className="font-display text-2xl text-[#F3F4F6] md:text-[26px]">{f.title}</h3>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-[#9CA3AF] md:text-base">{f.text}</p>
    </motion.div>
  );
};

export const Features = () => (
  <section id="features" className="relative border-t border-white/10 py-28 md:py-40" data-testid="features">
    <div className="ec-container">
      <Reveal className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="ec-eyebrow mb-4">
            <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
            ÖZELLİKLER
          </p>
          <h2 className="max-w-2xl font-display text-4xl leading-[1.02] tracking-tight text-[#F3F4F6] sm:text-5xl md:text-6xl">
            Standartları birleştiren tek defter.
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-[#9CA3AF] md:text-base">
          ISO 14064, GHG Protokolü, CBAM, ESRS, GRI ve SBTi — hepsi tek bir denetlenebilir kayıtta.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
        {FEATURES.map((f, i) => (
          <Card key={f.title} f={f} i={i} />
        ))}
      </div>
    </div>
  </section>
);
